import { Box, IconButton, Typography, Paper, Link, useTheme } from '@mui/material'
import { FC } from 'react'
import dayjs, { Dayjs } from 'dayjs'

// import LinkRouter from '../LinkRouter'
import { BoxStyle, BoxStyleTablet } from './styled'

import { FavoriteBorder } from '@mui/icons-material'

import { useActions } from '../../hooks/useActions'

require('dayjs/locale/uk')

interface Props {
    isProject: boolean,
    urlSlug: string,
    title: string,
    description: string,
    imagePreview: string,
    date: Dayjs,
    announcementTime: string,
    hashtags: Array<string>
}

const AnnouncementItemTablet: FC<Props> = ({ isProject, urlSlug, title, description, imagePreview, date, announcementTime, hashtags }) => {
    const { palette } = useTheme();

    return (
        <Link underline="none" color="unset" href={isProject ? `/projects/${urlSlug}` : `/announcements/${urlSlug}`}>
            <BoxStyleTablet background={isProject ? "#fff" : palette.primary.dark} >
                <Box sx={{ position: "relative", width: { xs: "276px", md: "253px" }, height: { xs: "168px", md: "150px" } }}>
                    <img
                        loading="lazy"
                        style={{ width: "inherit", height: "inherit", borderRadius: "7px" }}
                        src={imagePreview}
                        alt="image"
                    />
                    <Box sx={{ display: "flex", position: "absolute", bottom: "8px", left: "8px" }}>
                        {hashtags.map((row, index) => {
                            return (
                                <Typography
                                    key={`announcement_hashtag_${index}`}
                                    variant="h6"
                                    fontFamily="Fixel Display, sans-serif"
                                    fontSize={{ xs: "9px", md: "12px" }} lineHeight="18px"
                                    fontWeight="600"
                                    sx={{

                                        background: palette.primary.main,
                                        borderRadius: "4px",
                                        px: "3px",
                                        mr: "6px"
                                    }}
                                >
                                    {row}
                                </Typography>
                            );
                        })}
                    </Box>
                </Box>
                <Typography variant="h5" fontFamily="Fixel Display, sans-serif" fontSize={{ xs: "16px", md: "15px" }} lineHeight={{ xs: "24px", md: "21px" }} color={isProject ? palette.primary.dark : "inherit"} fontWeight="800" sx={{ height: { xs: "72px", md: "65px" }, mt: "6px" }}>
                    {title}
                </Typography>
                <Typography variant="h6" fontFamily="Fixel Display, sans-serif" fontSize={{ xs: "12px", md: "14px" }} lineHeight={{ xs: "15px", md: "18px" }} color={isProject ? palette.background.default : palette.text.secondary} sx={{ height: { xs: "30px", md: "36px" }, mt: { xs: "4px", md: "0px" } }}>
                    {description}
                </Typography>
                <Typography variant="h6" fontFamily="Fixel Display, sans-serif" color={isProject ? palette.primary.dark : "inherit"} fontWeight="600" sx={{ height: "24px", mt: "17px" }}>
                    {dayjs(date).locale('uk').format('DD MMMM')} {announcementTime}
                </Typography>
            </BoxStyleTablet>
        </Link >

    )
}

export default AnnouncementItemTablet;